module.exports = __webpack_public_path__ + "static/oben-13d201a5dbef7a5022e76a97e0486fb2.jpg";